module.exports = __webpack_public_path__ + "img/wwd.a2b423d5.svg";